import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 text-foreground-900 font-heading text-lg font-semibold mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">
                P
              </span>
              蜜桃臀塑形指南
            </Link>
            <p className="text-foreground-600 text-sm leading-relaxed">
              科学打造完美翘臀曲线，汇集专业训练方案、饮食建议与常见误区解析。
            </p>
          </div>

          <div>
            <h4 className="text-foreground-900 font-semibold text-sm mb-4">训练分类</h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-foreground-600 hover:text-primary-600 text-sm transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-900 font-semibold text-sm mb-4">快速链接</h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/about" className="text-foreground-600 hover:text-primary-600 text-sm transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/training-moves" className="text-foreground-600 hover:text-primary-600 text-sm transition-colors">
                  训练动作
                </Link>
              </li>
              <li>
                <Link to="/category/diet-nutrition" className="text-foreground-600 hover:text-primary-600 text-sm transition-colors">
                  饮食营养
                </Link>
              </li>
              <li>
                <Link to="/category/common-myths" className="text-foreground-600 hover:text-primary-600 text-sm transition-colors">
                  常见误区
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-900 font-semibold text-sm mb-4">免责声明</h4>
            <p className="text-foreground-600 text-sm leading-relaxed">
              本站内容仅供健身参考，不构成医疗建议。在开始任何新的训练或饮食计划前，请咨询专业医疗人员。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} 蜜桃臀塑形指南. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-foreground-700 text-sm transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-foreground-500 hover:text-foreground-700 text-sm transition-colors" rel="nofollow">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}